import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697","key":"svg-0"}],["path",{"d":"M18 12v-5a2 2 0 0 0 -2 -2h-2","key":"svg-1"}],["path",{"d":"M8 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2","key":"svg-2"}],["path",{"d":"M8 11h4","key":"svg-3"}],["path",{"d":"M8 15h3","key":"svg-4"}],["path",{"d":"M14 17.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0","key":"svg-5"}],["path",{"d":"M18.5 19.5l2.5 2.5","key":"svg-6"}]]

const IconReportSearch = createReactComponent('outline', 'report-search', 'ReportSearch', __iconNode);

export default IconReportSearch;